export const SearchIcon = () => {
	return (
		<svg
			width='30'
			height='30'
			viewBox='0 0 30 30'
			fill='none'
			xmlns='http://www.w3.org/2000/svg'
		>
			<circle
				cx='12.1871'
				cy='12.1875'
				r='11.0113'
				stroke='#222222'
				stroke-width='1.83521'
			/>
			<path
				d='M12.1873 6.68164C11.4643 6.68164 10.7483 6.82405 10.0804 7.10073C9.41239 7.37742 8.80545 7.78296 8.2942 8.2942C7.78296 8.80545 7.37742 9.41239 7.10073 10.0804C6.82405 10.7483 6.68164 11.4643 6.68164 12.1873'
				stroke='#222222'
				stroke-width='1.83521'
				stroke-linecap='round'
			/>
			<path
				d='M28.7039 28.7044L23.1982 23.1987'
				stroke='#222222'
				stroke-width='1.83521'
				stroke-linecap='round'
			/>
		</svg>
	);
};
